import { render, staticRenderFns } from "./SystemManagement.vue?vue&type=template&id=509a1a33&scoped=true&"
import script from "./SystemManagement.vue?vue&type=script&lang=js&"
export * from "./SystemManagement.vue?vue&type=script&lang=js&"
import style0 from "./SystemManagement.vue?vue&type=style&index=0&id=509a1a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a1a33",
  null
  
)

export default component.exports